import { useUser } from "@/app/context/UserContext";
import { iProjectQa, iProProjectMain } from "@/app/models/interfaceProject";
import { Check, ChevronDown, ChevronLeft, ChevronRight, ChevronUp, FileUp, Minus, Pencil, Plus, Search, Trash2, X } from "lucide-react";
import { useEffect, useState } from "react";
import DatacenterUpload from "./DatacenterUpload";
import { useConfig } from "@/app/context/ConfigContext";
import { TypeEnvironment } from "@/app/constants/enums";

 

export default function QaSave() {
  const {userProject,setUserProject} = useUser();
  const { queryParams} = useConfig();
  const [isEditingForm, setIsEditingForm] = useState(true);    
  useEffect(() => {  
    if(userProject.project.env == TypeEnvironment.Prod){ 
      setIsEditingForm(false);
    } 
  }, []);
  
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const itemsPerPage = 5;
  const [editingIndex, setEditingIndex] = useState<string | null>(null);
  
  const [newQuestion, setNewQuestion] = useState("");
  const [newAnswer, setNewAnswer] = useState("");
  
  const [editQuestion, setEditQuestion] = useState("");
  const [editAnswer, setEditAnswer] = useState("");

  const [viewAdd, setViewAdd] = useState(false);

  const handleAdd = () => {
    if (!newQuestion.trim() || !newAnswer.trim()) {
      alert("Pregunta y respuesta son obligatorias");
      return;
    } 
    setUserProject((prevProject:iProProjectMain) => ({
      ...prevProject,
      qa: [
        { chunk_overlap: "1", chunk_size: "6000", question: newQuestion, answer: newAnswer, deleted: false, qa_id_local: crypto.randomUUID() },
          ...(prevProject.qa || [])] 
    }));
    setNewQuestion("");
    setNewAnswer(""); 
    setViewAdd(!viewAdd);
  };

  
  const changeEdit = (vParam:iProjectQa) => {
    setEditAnswer(vParam.answer);
    setEditQuestion(vParam.question); 
    setEditingIndex(vParam.qa_id_local);
  };

  const handleEdit = (index: string) => {
    //if (!userProject.qa[index].question.trim() || !userProject.qa[index].answer.trim()) {
    //  alert("Pregunta y respuesta son obligatorias");
    //  return;
    //}
    if (!editQuestion.trim() || !editAnswer.trim()) {
      alert("Pregunta y respuesta son obligatorias");
      return;
    } 

    setUserProject((prevProject: iProProjectMain) => {
      const updatedQa = [...prevProject.qa];
      const updatedQaNdx = prevProject.qa.findIndex(O=>O.qa_id_local == index); 
      updatedQa[updatedQaNdx] = { ...updatedQa[updatedQaNdx],question: editQuestion, answer:editAnswer, edit:updatedQa[updatedQaNdx].qa_id?true:false };
      return {
        ...prevProject,
        qa: updatedQa
      };
    }); 
    setEditQuestion("");
    setEditAnswer(""); 
    setEditingIndex(null);
  };
/*
  const handleInputChange = (index: number, field: keyof iProjectQa, value: string) => { 
    setUserProject((prevProject: iProProjectMain) => {
      const updatedQa = [...prevProject.qa];
      updatedQa[index] = { ...updatedQa[index], [field]: value }; 
      return {
        ...prevProject,
        qa: updatedQa
      };
    });
    

  };*/

  const handleDelete = (qa_id_local: string) => {
    setUserProject((prevProject: iProProjectMain) => {
      return {
        ...prevProject,
        qa: prevProject.qa.filter(O=>!O.deleted)
          .map((item) =>
            item.qa_id_local === qa_id_local && item.qa_id
              ? { ...item, deleted: true }
              : item
          )
          .filter((item) =>
            item.qa_id_local === qa_id_local ? !!item.qa_id : true
          ),
      };
    });
  };
  

  //const filteredData = userProject.qa.filter(
  //  (item) => !item.deleted && (item.question || "").includes(search)
  //);
 

  const filteredData = userProject.qa.filter(
    (item) => 
      !item.deleted &&
      (item.question?.toLowerCase().includes(search.trim().toLowerCase()) || 
       item.answer?.toLowerCase().includes(search.trim().toLowerCase()))
  );


  const paginatedData = filteredData.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );


  // Carga Masiva
  const [isOpenFileUpload, setIsOpenFileUpload] = useState(false);

  const handleUpload = (vQa: iProjectQa[]) => { 
    setUserProject((prevProject: iProProjectMain) => ({
        ...prevProject,
        qa: [
            ...vQa,
            ...(prevProject.qa || [])
        ],
    })); 
    setIsOpenFileUpload(false);
    
  };

  useEffect(() => {
    setPage(1); // Reiniciar siempre la paginación cuando cambie la data
  }, [userProject.qa.length]);

  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const toggleSelect = (qa_id_local: string) => {
    setSelectedItems((prev) =>
      prev.includes(qa_id_local)
        ? prev.filter((id) => id !== qa_id_local)
        : [...prev, qa_id_local]
    );
  };

  const handleDeleteSelected = () => {
    if (selectedItems.length === 0) {
      alert("No hay preguntas seleccionadas para eliminar.");
      return;
    }


    setUserProject((prevProject: iProProjectMain) => {
      return {
        ...prevProject,
        qa: prevProject.qa
          .filter((O) => !O.deleted)
          .map((item) =>
            selectedItems.includes(item.qa_id_local) && item.qa_id
              ? { ...item, deleted: true }
              : item
          )
          .filter(
            (item) =>
              selectedItems.includes(item.qa_id_local) ? !!item.qa_id : true
          ),
      };
    });

    setSelectedItems([]); // limpiar selección
  };
  const toggleSelectAll = () => {
    const currentIds = paginatedData.map((item) => item.qa_id_local);
    const allSelected = currentIds.every((id) => selectedItems.includes(id));

    setSelectedItems((prev) =>
      allSelected
        ? prev.filter((id) => !currentIds.includes(id))
        : [...new Set([...prev, ...currentIds])] 
    );
  };

  return (
    <div className="w-full" key={userProject.qa.length}>
      <h2 className="text-lg font-bold mb-4">Preguntas y Respuestas</h2>
      <div className="flex gap-2 mb-4">
        <div className="relative flex-1">
          <input
            type="text"
            placeholder="Buscar pregunta..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full border rounded n-fmr-input-search border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-700"
          />
          <Search className="absolute right-2.5 top-3.5 text-gray-400" size={18} />
        </div>
        <button onClick={()=>setIsOpenFileUpload(true)} 
          className={`flex items-center btn-inca-secondary justify-center px-2 py-2 w-10 h-10 rounded-full bg-gray-100 transition-colors border shadow-md  hover:bg-gray-200 
            ${isEditingForm?"":"hidden" }`}
          disabled={!isEditingForm}
        >
          <FileUp className="w-6 h-6 animate-fade-in" strokeWidth={1.5} /> 
        </button> 
        <button onClick={()=>{setViewAdd(true);setNewQuestion(""); setNewAnswer("");  }} 
          className={`flex items-center btn-inca-secondary justify-center px-2 py-2 w-10 h-10 rounded-full bg-gray-100 transition-colors border shadow-md  hover:bg-gray-200 
            ${isEditingForm?"":"hidden" }`}
          disabled={!isEditingForm}
        >
          <Plus className="w-6 h-6 animate-fade-in" strokeWidth={1.5} /> 
        </button> 
        {selectedItems.length > 0 && (
          <button
            onClick={handleDeleteSelected}
            className="flex items-center text-white justify-center px-3 py-2 rounded bg-red-600 hover:bg-red-800 transition-colors border shadow-md"
          >
            <Trash2 className="w-4 h-4 mr-2" strokeWidth={1.5} />
            Eliminar seleccionados ({selectedItems.length})
          </button>
        )}
      </div>
 
      <div className={`flex justify-between items-start ${ viewAdd ? '' : 'hidden'} animate-fade-in`}>
        <div className="flex flex-col w-full">
          <label className="block text-sm font-medium">Pregunta</label>
          <input
            type="text"
            placeholder="Nueva Pregunta"
            value={newQuestion}
            onChange={(e) => setNewQuestion(e.target.value)}
            className="w-full border n-fmr-input my-2 px-3 py-2 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-700" 
          />
          <label className="block text-sm font-medium">Respuesta</label>
          <textarea
            placeholder="Nueva Respuesta"
            value={newAnswer} 
            rows={2}
            required
            onChange={(e) => setNewAnswer(e.target.value)}
            className="w-full p-2 border n-fmr-input border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-700"
          /> 
        </div>
        <div className="flex flex-col py-2 px-2 justify-end">
          <button 
              onClick={() => { handleAdd();  }} 
              className={`flex items-center text-white justify-center px-2 py-2 rounded-full bg-blue-600 transition-colors border shadow-md hover:bg-blue-800 
                ${isEditingForm?"":"hidden" }`}
              disabled={!isEditingForm}
            > 
              <Check className="w-5 h-5 animate-fade-in" strokeWidth={1.5} /> 
            </button> 
            <button 
              onClick={() => setViewAdd(!viewAdd)} 
              className="flex items-center btn-inca-secondary justify-center px-2 py-2 rounded-full transition-colors border shadow-md"
              disabled={!isEditingForm}
            > 
              <X className="w-5 h-5 animate-fade-in" strokeWidth={1.5} /> 
            </button> 
        </div> 
      </div>

 

        <div className="flex items-center gap-2 mb-2 px-2">
          <input
            type="checkbox"
            checked={
              paginatedData.length > 0 &&
              paginatedData.every((item) => selectedItems.includes(item.qa_id_local))
            }
            onChange={toggleSelectAll}
            className="accent-blue-600 w-4 h-4 cursor-pointer"
          />
          <span className="text-sm font-semibold text-gray-700">
            Seleccionar todos ({paginatedData.length})
          </span>
        </div>        
      {paginatedData.filter(O=>!O.deleted).map((item) => (
        <div key={`qa-${item.qa_id_local}`} className="flex justify-between items-center border-b text-sm font-medium animate-fade-in py-2 px-2">
          
          <div className="flex items-center gap-3 w-full">
              <input
                type="checkbox"
                checked={selectedItems.includes(item.qa_id_local)}
                onChange={() => toggleSelect(item.qa_id_local)}
                className="accent-blue-600 w-4 h-4 cursor-pointer"
              />
          <div className="flex flex-col w-full">
            {editingIndex === item.qa_id_local ? (
              <>
                <label className="block text-sm font-medium">Pregunta</label>
                <input
                  type="text"
                  placeholder="Pregunta"
                  value={editQuestion}
                  onChange={(e) => setEditQuestion(e.target.value)}
                  className="w-full border n-fmr-input my-2 px-3 py-2 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-700"
                />
                <label className="block text-sm font-medium">Respuesta</label>
                <textarea
                  placeholder="Respuesta"
                  value={editAnswer}
                  onChange={(e) => setEditAnswer(e.target.value)}
                  rows={2}
                  required
                  className="w-full p-2 border n-fmr-input border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-700"
                />
              </>
            ) : (
              <>
                <p className="font-bold">{item.question}</p>
                <p>{item.answer}</p>
              </>
            )}
          </div>
          </div>

          <div className="flex flex-col py-2 px-2 justify-end">
            <button 
              onClick={() => editingIndex === item.qa_id_local ? handleEdit(item.qa_id_local) : changeEdit(item)}
              className={`flex items-center text-white justify-center px-2 py-2 rounded-full bg-blue-600 transition-colors border shadow-md hover:bg-blue-800
                ${isEditingForm?"":"hidden" }`}
              disabled={!isEditingForm}
            > 
                {editingIndex === item.qa_id_local ? 
                <Check className="w-4 h-4 animate-fade-in" strokeWidth={1.5} /> : 
                <Pencil className="w-4 h-4 animate-fade-in" strokeWidth={1.5} /> } 

            </button> 
            <button 
              onClick={() => handleDelete(item.qa_id_local)}
              className={`flex items-center btn-inca-secondary justify-center px-2 py-2 rounded-full transition-colors border shadow-md
              ${isEditingForm?"":"hidden" }`}
              disabled={!isEditingForm}
            > 
              <Trash2 className="w-4 h-4 animate-fade-in" strokeWidth={1.5} /> 
            </button> 
          </div> 

        </div>
      ))}


      {(filteredData.length > itemsPerPage)&&( 
          <div className="flex justify-end items-center mt-1"> 
            
                <button
                  onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                  disabled={page < 1}
                  className={`p-1 border bg-slate-50 text-blue-500 rounded-full disabled:opacity-50 mr-2 shadow-lg 
                    ${page > 1 ? "hover:shadow-xl hover:bg-white hover:border-blue-400  ":" text-slate-400"}
                    `}
                >
                    <ChevronLeft />
                </button> 
            
            <span className="p-2 pt-2 pb-2 bg-blue-700 text-white rounded-full disabled:opacity-50 mr-2">
              {page} / {Math.ceil(filteredData.length / itemsPerPage)}  
            </span>
            
                <button
                  onClick={() => setPage((prev) => (page * itemsPerPage < filteredData.length ? prev + 1 : prev))}
                  disabled={page * itemsPerPage >= filteredData.length}
                  className={`p-1 border bg-slate-50 text-blue-500 rounded-full disabled:opacity-50 mr-2 shadow-lg 
                      ${(page * itemsPerPage >= filteredData.length) ? "text-slate-400": "hover:shadow-xl hover:bg-white hover:border-blue-400 "}`}
                >
                    <ChevronRight />
                </button>
            
          </div> 
        )} 

      {/*
      <div className="flex justify-between mt-4"> 
        <button onClick={() => setPage((prev) => Math.max(prev - 1, 1))} disabled={page === 1} className="px-3 py-1 bg-gray-200 rounded">Anterior</button>
        <button onClick={() => setPage((prev) => (page * itemsPerPage < filteredData.length ? prev + 1 : prev))} disabled={page * itemsPerPage >= filteredData.length} className="px-3 py-1 bg-gray-200 rounded">Siguiente</button>
      </div>
      */}
      
      <DatacenterUpload onUpload={handleUpload} isOpen={isOpenFileUpload} onClose={() => setIsOpenFileUpload(false)} paramQa={true}/>

    </div>
  );
}